<style lang="scss" scoped>
  @import '../../styles/vars/main';
  @import '../../styles/helpers/main';
  .edit {
    display: flex;
    flex-direction: column;
    height: 100%;
    &__headline {
      margin-bottom: space('comfortable');
    }
    &__title {
      margin-bottom: space('comfortable');
    }
    &__description {
      height: 100%;
      margin-bottom: space('comfortable');
    }
    &__footer {
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
    }
  }
</style>
<template>
  <div class="edit">
    <v-headline :level="'3'" cssClass="edit__headline">Edit Title and Description</v-headline>
    <input type="text" spellcheck="false" :name="'title'" :value="title" class="textfield --headline --black edit__title" ref="newHeadline" autocomplete="false">
    <!-- <v-textfield :name="'title'" :value="title" cssClass="--headline" @keyup="click"></v-textfield> -->
    <textarea spellcheck="false" class="textarea edit__description" name="" id="" cols="30" rows="10" ref="newDescription" :value="description">
      </textarea>
    <div class="edit__footer">
      <v-button cssClass="button --secondary" @click="cancel">Abbrechen</v-button>
      <v-button @click="save">Speichern</v-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Headline from '../headline';
import Textfield from '../textfield';
import Button from '../button';
import pluralSingular from '../../mixins/pluralSingular.js';

export default {
  components: {
    'v-headline': Headline,
    'v-textfield': Textfield,
    'v-button': Button
  },
  data() {
    return {
      newTitle: ''
    };
  },
  props: {

  },
  mounted() {

  },
  computed: {
    ...mapGetters([
      'overlay_isOpen',
      'view',
      'activeId'
    ]),
    parentId() {
      const breadcrumb = this.$store.getters.breadcrumb;
      if (breadcrumb) {
        return breadcrumb.length > 1 ? breadcrumb[breadcrumb.length - 2].id : breadcrumb[0].id;
      }
    },
    data() {
      const data = this.$store.getters[this.plural(this.view)];

      if (data) {
        const item = data.find(item => {
          return item.id.toString() === this.activeId.toString();
        });
        return item;
      };
    },
    title() {
      return this.data.name;
    },
    description() {
      return this.data.description;
    }
  },
  mixins: [
    pluralSingular
  ],
  methods: {
    updateTitle(newTitle) {
      this.newTitle = newTitle;
    },
    save() {
      const apiPath = `${this.view}/${this.activeId}`;
      const target = this.plural(this.view);
      const parentId = this.parentId;
      const targetId = this.data.id;
      const title = this.$refs.newHeadline.value;
      const description = this.$refs.newDescription.value;
      const folder = title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      this.$store.dispatch('update', { props: { 'name': title, 'description': description, 'folder': folder }, apiPath, target, parentId, targetId }).then((data) => {
      });
    },
    cancel() {
      this.$store.commit('overlay_isOpen', false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/album/edit.vue